import Logger from './logger';

/**
 * Safely parse user comments JSON string. Returns null on parse failure
 * so callers can decide whether to proceed or abort.
 *
 * @param rawComments - The raw comments string from the payment record
 * @param context - Description of where this is being called for logging
 * @returns Parsed comments array, empty array if null/empty, or null on parse failure
 */
export function safeParseComments(rawComments, context) {
    if (!rawComments) return [];
    try {
        return JSON.parse(rawComments);
    } catch (e) {
        Logger.logError(`Failed to parse user comments (${context}): ${e.message}`);
        return null;
    }
}
